import { find } from "lodash"
import React, { useState } from "react"

import MoneyInput from "../../inputs/MoneyInput"
import BackArrow from "../../BackArrow"

import { postRequest } from "../../../helpers/api"

const initialValues = {
  asset_sub_type: "capital",
  interest_rate: "",
  provider_name: "",
  current_value: "",
}

const Mortgage = ({ onBack, onSuccess, hideTitle }) => {
  const [isSaving, setIsSaving] = useState(false)
  const [errors, setErrors] = useState({})
  const [form, setValues] = useState({ ...initialValues })

  return (
    <>
      {!hideTitle &&
        <>
          <BackArrow onClick={onBack} />
          <h1 className="page-title">Add a mortgage</h1>
        </>
      }

      <form
        onSubmit={async e => {
          e.preventDefault()

          if (isSaving) return

          setIsSaving(true)

          console.log("Submit form", form)

          const resp = await postRequest(`/api/assets`, { asset_category: "mortgage", ...form })
          const json = await resp.json()

          if (resp.status === 201) {
            console.log("success", json)
            onSuccess(json.data)
          } else {
            console.log("failed resp", resp)
            setErrors(json.validation_errors)
          }

          setIsSaving(false)
        }}
      >
        <div className="form-field -maxlength">
          <label htmlFor="asset_sub_type">Mortgage type</label>
          <select id="asset_sub_type" value={form.asset_sub_type} onChange={e => setValues({ ...form, asset_sub_type: e.target.value })}>
            <option value="capital">Capital</option>
            <option value="interest_only">Interest only</option>
            <option value="fixed">Fixed rate</option>
            <option value="discounted">Discounted rate</option>
            <option value="tracker">Tracker</option>
            <option value="svr">SVR (Standard variable rate)</option>
          </select>
          {find(errors, row => row.field === "asset_sub_type") && <span className="hint -error">{find(errors, row => row.field === "asset_sub_type").errors.join(", ")}</span>}
        </div>

        {form.asset_sub_type === "interest_only" &&
          <div className="form-field -maxlength">
            <label htmlFor="interest_rate">Interest rate</label>
            <input type="text" id="interest_rate" value={form.interest_rate} onChange={e => setValues({ ...form, interest_rate: e.target.value })} />
            {find(errors, row => row.field === "interest_rate") && <span className="hint -error">{find(errors, row => row.field === "interest_rate").errors.join(", ")}</span>}
          </div>
        }

        <div className="form-field -maxlength">
          <label htmlFor="provider_name">Provider name</label>
          <input type="text" id="provider_name" placeholder="e.g. Santander" value={form.provider_name} onChange={e => setValues({ ...form, provider_name: e.target.value })} />
          {find(errors, row => row.field === "provider_name") && <span className="hint -error">{find(errors, row => row.field === "provider_name").errors.join(", ")}</span>}
        </div>

        <div className="form-field -maxlength">
          <label htmlFor="current_value">Mortgage amount</label>
          <MoneyInput id="current_value" defaultValue={form.current_value} onChange={current_value => setValues({ ...form, current_value })} />
          {find(errors, row => row.field === "current_value") && <span className="hint -error">{find(errors, row => row.field === "current_value").errors.join(", ")}</span>}
        </div>

        <div className="flex items-center">
          <button disabled={isSaving} type="submit" className="button -primary mr3">
            {isSaving ? 'Saving...' : 'Add mortgage'}
          </button>
          <button disabled={isSaving} onClick={onBack} className="button">Cancel</button>
        </div>
      </form>
    </>
  )
}

export default Mortgage
